import { DEFAULT_CHART_HEIGHT } from './chart_config';
import type { ChartConfigInterface, ChartVariantsType } from 'src/types/Chart';

export const getOverAllChartsConfig = (type: ChartVariantsType): ChartConfigInterface => {
	return {
		url: 'v2/statistics/power-consumption/overall',
		charts: [
			{
				name: 'overall_consumption',
				type,
				series: [
					{
						visible: true,
						name: 'consumption',
						style: 'overall_consumption',
						stack: 'overall',
					},
					{
						visible: true,
						name: 'reversed',
						style: 'overall_reversed',
						stack: 'overall',
					},
				],
				units: 'Wh',
				height: DEFAULT_CHART_HEIGHT,
			},
		],
	};
};
